import { BudgetMemberFormValues } from '@/components/organisms/budget/form-steps/budgetStep.schema';

export interface BudgetMemberCalculations {
  allOreHoursFilled: boolean;
  hasPartialOreHours: boolean;
  bhov: number | null;
  btev: number | null;
  currency: string;
}

const hasOreHours = (member: BudgetMemberFormValues): boolean => {
  const hours = member.oreHours;

  if (hours == null || hours === undefined) {
    return false;
  }

  const num = Number(hours);
  return !isNaN(num) && num >= 0;
};

export const getBudgetMemberCalculations = (
  members: BudgetMemberFormValues[] = [],
  bmev: number | string = 0,
  currency = 'EUR'
): BudgetMemberCalculations => {
  if (!members.length) {
    return {
      allOreHoursFilled: false,
      hasPartialOreHours: false,
      bhov: null,
      btev: null,
      currency
    };
  }

  const filledCount = members.filter(hasOreHours).length;
  const allOreHoursFilled = filledCount === members.length;
  const hasPartialOreHours = filledCount > 0 && !allOreHoursFilled;

  if (!allOreHoursFilled) {
    return {
      allOreHoursFilled: false,
      hasPartialOreHours,
      bhov: null,
      btev: null,
      currency
    };
  }

  const bhov = members.reduce((sum, member) => {
    return sum + Number(member.oreHours) * (Number(member.hourlyRate) || 0);
  }, 0);

  return {
    allOreHoursFilled: true,
    hasPartialOreHours: false,
    bhov,
    btev: (Number(bmev) || 0) + bhov,
    currency
  };
};

export const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case 'USD':
      return '$';
    case 'GBP':
      return '£';
    default:
      return '€';
  }
};

export const formatBudgetCalculationAmount = (amount: number, currency: string): string => {
  return `${getCurrencySymbol(currency)}${amount.toLocaleString()}`;
};
